import React from "react"
import { Text } from "@chakra-ui/react"

type Props = {
  productTitle?: string
}

export const DetailsAndCare: React.FC<Props> = ({ productTitle }) => {
  if (productTitle === "Crew Neck Sweatshirt")
    return (
      <Text variant="acuminLight">
        Machine wash at 40 degrees. Do not bleach. Some internal fibre transfer
        may occur on first wear - wash to prevent this.
      </Text>
    )
  return (
    <>
      <Text variant="acuminLight">
        Machine wash at 30ºC. Wash with similar colours. Cool iron only. Do not
        bleach. Do not tumble dry.
      </Text>

      <Text variant="acuminLight">
        MAIN FABRIC: 90% OEKO-TEX Viscose & 10% Elastane.
        <br />
        BUTTONS: 60% PCR Plastic.
        <br />
        PACKAGING: Polybag made from Recycled Plastic (recyclable with soft
        plastics). Swing-tag (recyclable with paper).
      </Text>
    </>
  )
}
